export class JobManagerContact {
    fullName: string;
    email: string;
    phoneNumber: string;
    profileImageUrl: string;
    userId: number;
    roleName: string;
    initials: string;
}
